/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Confirm_YesInputs */

const en_new_project_confirm_yes = /** @type {(inputs: New_Project_Confirm_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const fr_new_project_confirm_yes = /** @type {(inputs: New_Project_Confirm_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_new_project_confirm_yes = /** @type {(inputs: New_Project_Confirm_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_new_project_confirm_yes = /** @type {(inputs: New_Project_Confirm_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SÌ`)
};

const ru_new_project_confirm_yes = /** @type {(inputs: New_Project_Confirm_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const es_new_project_confirm_yes = /** @type {(inputs: New_Project_Confirm_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const zh_cn2_new_project_confirm_yes = /** @type {(inputs: New_Project_Confirm_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的`)
};

const ja_new_project_confirm_yes = /** @type {(inputs: New_Project_Confirm_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const hi_new_project_confirm_yes = /** @type {(inputs: New_Project_Confirm_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const pt_pt2_new_project_confirm_yes = /** @type {(inputs: New_Project_Confirm_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {New_Project_Confirm_YesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_confirm_yes = /** @type {((inputs?: New_Project_Confirm_YesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Confirm_YesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_confirm_yes(inputs)
	if (locale === "de") return de_new_project_confirm_yes(inputs)
	if (locale === "it") return it_new_project_confirm_yes(inputs)
	if (locale === "ru") return ru_new_project_confirm_yes(inputs)
	if (locale === "es") return es_new_project_confirm_yes(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_confirm_yes(inputs)
	if (locale === "ja") return ja_new_project_confirm_yes(inputs)
	if (locale === "hi") return hi_new_project_confirm_yes(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_confirm_yes(inputs)
	return en_new_project_confirm_yes(inputs)
});